import { useEffect, useState } from 'react';
import { getWebBaseURL } from '../utils';

export const useWebBaseURL = () => {
  const [webUrl, setWebUrl] = useState<string | null>(null);

  useEffect(() => {
    getWebBaseURL().then(setWebUrl);
  }, []);
  return webUrl;
};
